function VehiclePolicyHolderHandler(Util, publicIDTransformer) {

	function handle(quoteRequest, userInput) {

		var mainPolicyholder = quoteRequest.policyHolders.filter(function (item) {
			return item['mainHolder'];
		})[0];

		var mainDriver = quoteRequest.vehicles[0].drivers.filter(function (item) {
			return item['driverUsage'] == 'main';
		})[0];

		if ((!userInput.vehicleForm.mainPolicyHolder ||
				(userInput.vehicleForm.mainPolicyHolder && userInput.vehicleForm.mainPolicyHolder.isMainDriverMainPolicyHolder)) && userInput.vehicleForm.getStarted.personOrCompany != "company") {
			mainPolicyholder.contact.publicID = mainDriver.driver.person.publicID;
		} else if (userInput.vehicleForm.mainPolicyHolder != undefined && userInput.vehicleForm.mainPolicyHolder.isMainDriverMainPolicyHolder != undefined &&
			!userInput.vehicleForm.mainPolicyHolder.isMainDriverMainPolicyHolder &&
			mainPolicyholder.contact.publicID == mainDriver.driver.person.publicID) {
			quoteRequest = publicIDTransformer.transform(quoteRequest);
			delete quoteRequest.secret;
			delete quoteRequest.quoteID;
		}

		if (mainPolicyholder.contact.publicID == mainDriver.driver.person.publicID) {
			mainDriver.driver.person.passwordQuestion = mainPolicyholder.contact.passwordQuestion;
			mainDriver.driver.person.passwordAnswer = mainPolicyholder.contact.passwordAnswer;
			mainDriver.driver.person.primaryPhone = mainPolicyholder.contact.primaryPhone;

			switch (mainPolicyholder.contact.primaryPhone) {
				case 'mobile':
					mainDriver.driver.person.cellPhone = mainPolicyholder.contact.cellPhone;
					break;
				case 'home':
					mainDriver.driver.person.homePhone = mainPolicyholder.contact.homePhone;
					break;
				case 'work':
					mainDriver.driver.person.workPhone = mainPolicyholder.contact.workPhone;
					break;
			}

			delete mainPolicyholder.contact.drivingHistory;
		}

		return quoteRequest;
	}

	return {
		handle: handle
	}
};
